import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/exchanges`, {params: {...filters}})
  },

  create(exchange){
    return Http.post(`/exchanges`, {exchange: {...exchange}})
  },

  update(exchange){
    return Http.put(`/exchanges/${exchange.id}`, {
      exchange: {...exchange},
    });
  },

  show(id) {
    return Http.get(`/exchanges/${id}`);
  },

  delete(id){
    return Http.delete(`/exchanges/${id}`)
  }

}
